export const ROOT = 'typePublication';

export const FETCH_TYPE_PUBLICATION_REQUEST = `${ROOT}/FETCH_TYPE_PUBLICATION_REQUEST`;
export const FETCH_TYPE_PUBLICATION_FAILURE = `${ROOT}/FETCH_TYPE_PUBLICATION_FAILURE`;
export const FETCH_TYPE_PUBLICATION_SUCCESS = `${ROOT}/FETCH_TYPE_PUBLICATION_SUCCESS`;
